import { Injectable } from "@angular/core";
import { SimuladorSecondaryInterface } from "../../../core/ports/secondary/simulador.secondaty.interface";
import { Observable } from "rxjs";
import { CampusModel } from "../../../core/domain/campus.model";
import { InstitucionesModel } from "../../../core/domain/instituciones.model";
import { NivelAcademicosModel } from "../../../core/domain/nivelAcademico.model";
import { PeriodosModel } from "../../../core/domain/periodos.model";
import { ProgramasModel } from "../../../core/domain/programas.model";
import { HttpClient } from "@angular/common/http";
import { AreaModel } from "../../../core/domain/area.model";
import { CalcularRequestModel } from "../../../core/domain/params/requestCalcularRequest.model";
import { CalcularModel } from "../../../core/domain/calcular.model";
import { ApoyosModel } from "../../../core/domain/apoyos.model";
import { BecaModel } from "../../../core/domain/beca.model";
import { ParamApoyoModel } from "../../../core/domain/params/paramApoyo.model";
import { PrestamosModel } from "../../../core/domain/prestamos.model";
import { environment } from "src/environments/environment";
import { ParamCampusModel } from "../../../core/domain/params/paramCampus.model";
import { ParamPeriodoModel } from "../../../core/domain/params/paramPeriodo.model";
import { ParamProgramasModel } from "../../../core/domain/params/paramProgramas.model";
import { ParamAreaModel } from "../../../core/domain/params/paramArea.model";
import { MontoMaximo } from "../../../core/interfaces/monto-maximo";

@Injectable({
  providedIn: "root",
})
export class SimuladorService extends SimuladorSecondaryInterface {
  private readonly url = environment.URL_HOME;

  constructor(private http: HttpClient) {
    super();
  }

  getInstituciones(institucion: string): Observable<InstitucionesModel> {
    return this.http.get<InstitucionesModel>(`${this.url}/GetInstituciones`);
  }

  getNivelAcademico(institucion: string): Observable<NivelAcademicosModel> {
    return this.http.get<NivelAcademicosModel>(`${this.url}/GetNiveles`);
  }

  getCampus(params: ParamCampusModel): Observable<CampusModel> {
    return this.http.get<CampusModel>(`${this.url}/GetCampi`, {
      params: params as any,
    });
  }

  getPeriodos(params: ParamPeriodoModel): Observable<PeriodosModel> {
    return this.http.get<PeriodosModel>(`${this.url}/GetPeriodos`, {
      params: params as any,
    });
  }

  getProgramas(params: ParamProgramasModel): Observable<ProgramasModel> {
    return this.http.get<ProgramasModel>(`${this.url}/GetProgramas`, {
      params: params as any,
    });
  }

  getAreas(params: ParamAreaModel): Observable<AreaModel> {
    return this.http.get<AreaModel>(`${this.url}/GetAreas`, {
      params: params as any,
    });
  }

  calcular(request: CalcularRequestModel): Observable<CalcularModel> {
    return this.http.post<CalcularModel>(`${this.url}/PostCuotas`, request);
  }

  getBeca(institucion: string, nivelAcademico: string, periodo: string): Observable<BecaModel> {

    const params = { 
      institucion: institucion, 
      nivel: nivelAcademico, 
      periodo: periodo 
    };

    return this.http.get<BecaModel>(`${this.url}/GetBecas`, { params });
  }

  getApoyos(param: ParamApoyoModel): Observable<ApoyosModel> {
    const params = { ...param };
    return this.http.get<ApoyosModel>(`${this.url}/GetApoyos`, { params });
  }

  getPrestamos(institucion: string, nivelAcademico: string, periodo: string): Observable<PrestamosModel> {

    const params = {
      institucion: institucion,
      nivel: nivelAcademico,
      periodo: periodo
    };
    
    return this.http.get<PrestamosModel>(`${this.url}/GetPrestamos`, {
      params,
    });
  }

  getLimitesBecasPrestamos(institucion: string, nivelAcademico: string, periodo: string): Observable<MontoMaximo> {

    const params = {
      institucion: institucion,
      nivel: nivelAcademico,
      periodo: periodo
    };

    return this.http.get<MontoMaximo>(`${this.url}/GetLimitesBecasPrestamos`, {
      params
    });
  }

}
